export default __webpack_public_path__ + "static/media/champs.9f64db8b.jpg";